import { Controller } from "@hotwired/stimulus";

// The Search button on the Archive home and collection pages and the item
// page sidebar: shows or hides a search field. (Ask opens its dialog with
// invoker commands; see archive/shared/_ask_dialog.)
export default class extends Controller {
  static targets = ["searchToggle", "searchPanel", "searchInput"];

  toggleSearch() {
    this.searchPanelTarget.hidden ? this.openSearch() : this.closeSearch();
  }

  openSearch() {
    this.searchPanelTarget.hidden = false;
    this.searchToggleTarget.setAttribute("aria-expanded", "true");
    this.searchInputTarget.focus();
  }

  closeSearch() {
    if (this.searchPanelTarget.hidden) return;
    this.searchPanelTarget.hidden = true;
    this.searchToggleTarget.setAttribute("aria-expanded", "false");
  }
}
